export type JobType =
  | "jobs"
  | "early-careers"
  | "apprenticeships"
  | "internships";

export enum OrganizationTabsEnum {
  JOBS = "jobs",
  EARLY_CAREERS = "early-careers",
  APPRENTICESHIPS = "apprenticeships",
  INTERNSHIPS = "internships",
  REVIEWS = "reviews",
  ARTICLES = "articles",
  EVENTS = "events",
  PANELS = "panels",
  EMPLOYEES = "employees",
  INVITE_EMPLOYEES = "invite-employees",
  MANAGE_INVITES = "manage-invites",
}
